import React, {Component} from 'react';
import {NavLink, Redirect} from 'react-router-dom'

class Sidebar extends Component {

    handleClick(e) {
        e.preventDefault();
        e.target.parentElement.classList.toggle('open');

        if (e.currentTarget.attributes["data-island"]) {
            <Redirect to="/islands"/>
        }
    }

    activeRoute(routeName) {
        return this.props.location.pathname.indexOf(routeName) > -1 ? 'nav-item nav-dropdown open' : 'nav-item nav-dropdown';
    }

    // secondLevelActive(routeName) {
    //   return this.props.location.pathname.indexOf(routeName) > -1 ? "nav nav-second-level collapse in" : "nav nav-second-level collapse";
    // }

    render() {
        return (
            <div className="sidebar">
                <nav className="sidebar-nav">
                    <ul className="nav">
                        <li className="nav-item">
                            <NavLink to={'/dashboard'} className="nav-link" activeClassName="active"><i
                                className="icon-speedometer"></i> Dashboard <span
                                className="badge badge-info">NEW</span></NavLink>
                        </li>

                        <li className={this.activeRoute("/components")}>
                            <a className="nav-link nav-dropdown-toggle" href="#"
                               onClick={this.handleClick.bind(this)} data-island="true">
                                <i className="fa fa-fort-awesome"></i> Island Management</a>
                            <ul className="nav-dropdown-items">
                                <li className="nav-item">
                                    <NavLink to={'/islands'} className="nav-link" activeClassName="active"><i
                                        className="icon-puzzle"></i> All Islands</NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink to={'/islands/addisland'} className="nav-link" activeClassName="active"><i
                                        className="fa fa-university" aria-hidden="true"></i> Add Island</NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink to={'/islands/exclusivefeatures'} className="nav-link"
                                             activeClassName="active">
                                        <i className="fa fa-bed"></i> Exclusive Features</NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink to={'/categories/addcategory'} className="nav-link"
                                             activeClassName="active">
                                        <i className="fa fa-cog" aria-hidden="true"></i> Add Category</NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink to={'/categories'} className="nav-link"
                                             activeClassName="active">
                                        <i className="fa fa-cogs" aria-hidden="true"></i> All Categories</NavLink>
                                </li>
                            </ul>
                        </li>

                        <li className={this.activeRoute("/components")}>
                            <a className="nav-link nav-dropdown-toggle" href="#"
                               onClick={this.handleClick.bind(this)}><i className="fa fa-home" aria-hidden="true"></i>
                                Haute Management</a>
                            <ul className="nav-dropdown-items">
                                <li className="nav-item">
                                    <NavLink to={'/hautemngt/homepage'} className="nav-link" activeClassName="active"><i
                                        className="fa fa-list-alt" aria-hidden="true"></i> Home Page</NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink to={'/islands/comingsoon'} className="nav-link"
                                             activeClassName="active">
                                        <i className="fa fa-columns" aria-hidden="true"></i> Static Pages</NavLink>
                                </li>
                                <li className="nav-item">
                                    <NavLink to={'/hautemngt/socialmanagement'} className="nav-link"
                                             activeClassName="active">
                                        <i className="fa fa-twitter-square" aria-hidden="true"></i> Social
                                        Management</NavLink>
                                </li>
                            </ul>
                        </li>

                        <li className="nav-item">
                            <NavLink to={'/enquirydetails'} className="nav-link" activeClassName="active">
                                <i className="fa fa-list-alt"></i> Enquiry Details
                            </NavLink>
                        </li>

                    </ul>
                </nav>
            </div>
        )
    }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js